import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MarketBrandDirectoryRouter } from "@faire/retailer-visitor-shared/features/FaireMarkets/MarketBrandDirectoryRouter";
import { MarketPreshowRouter } from "@faire/retailer-visitor-shared/features/FaireMarkets/MarketPreshowRouter";
import { LazyFaireMarketsPage } from "@faire/retailer-visitor-shared/features/FaireMarkets/MarketsPage/LazyFaireMarketsPage";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { PreShowRouter } from "@faire/retailer-visitor-shared/views/promotional-events/pre-show/PreShowRouter";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as faireMarketsRouteProps } from "@faire/web-api--source/routes/markets";
import { props as marketBrandDirectoryRouteProps } from "@faire/web-api--source/routes/markets/brand-directory/event_type";
import { props as preShowPageProps } from "@faire/web-api--source/routes/markets/event_type/all-specials";
import { observer } from "mobx-react";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";
var MarketRouterBase = function() {
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsxs(Switch, {
            children: [
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, faireMarketsRouteProps), {
                    component: LazyFaireMarketsPage,
                    exact: true
                })),
                /*#__PURE__*/ _jsx(MarketPreshowRouter, {}),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, preShowPageProps), {
                    component: PreShowRouter
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, marketBrandDirectoryRouteProps), {
                    component: MarketBrandDirectoryRouter
                })),
                /*#__PURE__*/ _jsx(Redirect, {
                    to: home()
                })
            ]
        })
    });
};
export var MarketRouter = observer(MarketRouterBase);
